import * as React from "react";
import { Link } from "react-router-dom";
// import CardMedia from '@mui/material/CardMedia';
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import EmptyCard from "../../../../components/EmptyCard";
// import Logo from '../../images/logo-rentbeet.png';
import "./style.css";

export default function EmptyPropertyCard() {
  return (
    <EmptyCard className="empty-property-card">
      {/*
      <CardMedia
        component="img"
        height="140"
        image={Logo}
        alt="Rentbeets logo"
        sx={{
          backgroundColor: 'blue',
        }}
      />
      */}
      <Typography gutterBottom variant="h5" component="div">
        Add a Property
      </Typography>
      <Typography variant="body2" color="text.secondary">
        Begin leasing apartments faster than anyone else in the market! First
        add your property and then the specific unit you wish to lease.
      </Typography>
      <Box
        sx={{
          textAlign: "right",
          marginTop: 2,
        }}
      >
        <Button
          component={Link}
          to="/add-property"
          variant="contained"
          size="small"
        >
          Add property
        </Button>
      </Box>
    </EmptyCard>
  );
}
